import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  SCBottomBarContainer,
  SCButtonWrapper,
  SCButtonCircle,
  SCButtonLabel,
  SCButtonsRow,
  SCButtonIcon
} from 'components/AugmentedReality/Calibrate/BottomBar/styled'

interface BottomBarProps {
  switchCamera: () => void;
  onNext: () => void;
  onPrevious: () => void;
}

const BottomBar = ({ switchCamera, onNext, onPrevious  }: BottomBarProps) => {
  const { t } = useTranslation()
  const [animateSwitch, setAnimateSwitch] = useState(false)

  const triggerAnimate = (setter: (v: boolean) => void) => {
    setter(true)
    setTimeout(() => setter(false), 750)
  }

  return (
    <SCBottomBarContainer>
      <SCButtonsRow>
        <SCButtonWrapper onClick={onPrevious}>
          <SCButtonCircle $size="large">
            <SCButtonIcon src={'/static/ra/back.svg'} alt="Retour" />
          </SCButtonCircle>
          <SCButtonLabel>{t('augmentedReality.back')}</SCButtonLabel>
        </SCButtonWrapper>

        <SCButtonWrapper onClick={onNext}>
          <SCButtonCircle $size="xlarge">
            <SCButtonIcon src={'/static/ra/play.svg'} alt="Play" $size="xlarge" />
          </SCButtonCircle>
          <SCButtonLabel>{t('augmentedReality.calibrate.start')}</SCButtonLabel>
        </SCButtonWrapper>

        <SCButtonWrapper
          onClick={() => {
            triggerAnimate(setAnimateSwitch)
            switchCamera()
          }}
        >
          <SCButtonCircle $size="large" className={animateSwitch ? 'animate' : ''}>
            <SCButtonIcon src={'/static/ra/switch-camera.svg'} alt="Tourner la caméra" />
          </SCButtonCircle>
          <SCButtonLabel>{t('augmentedReality.calibrate.rotateCamera')}</SCButtonLabel>
        </SCButtonWrapper>
      </SCButtonsRow>
    </SCBottomBarContainer>
  )
}

export default BottomBar